<template>
	<van-overlay :show="isShow" z-index="99">
		<div class="loading">
			<van-loading color="#fff" size="36px" />
			<span>{{text}}</span>
		</div>
	</van-overlay>
</template>

<script>
export default {
	data() {
		return {

		}
	},
	model: {
		prop: 'isShow',
		event: 'change'
	},
	props: {
		isShow: {
			type: Boolean,
			default: false
		},
		text: {
			type: String,
			default: ""
		}
	}
}
</script>

<style lang="scss" scoped>
.loading {
	margin-top: 70%;
	display: flex;
	flex-direction: column;
	align-items: center;
	>span {
		margin-top: 0.16rem;
		color: #fff;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/loading/loading.vue